import { EntityState } from '@reduxjs/toolkit';
import { Translate } from '@ff-os/shared-utils/types/Translate';
import { GiftJson } from '@ff-scene-plugins/gift-shared/GiftJson';
import { Prefab } from '../Prefab';
import { editInput } from './editInput';
import { merge } from './merge';

export const mergeInputsInto = (
    prefab: Prefab,
    inputs: EntityState<GiftJson.Input<any>>,
    translate: Translate
) => {

    const result: EntityState<GiftJson.Input<any>> = {
        ids: prefab.inputs.ids,
        entities: {}
    };

    for (const id of prefab.variables.ids as string[]) {

        const variable = prefab.variables.entities[id]!;
        const prefabInput = localize(prefab.inputs.entities[id]!, translate);
        const userInput = inputs.entities[id];

        result.entities[id] = userInput
            ? merge(userInput, prefabInput, variable, 'inputIntoPrefab')
            : prefabInput;
    }

    return result;
};

const localize = (input: GiftJson.Input<any>, t: Translate): GiftJson.Input<any> => {
    return typeof input.value.content === 'string'
        ? editInput(input, { content: t(input.value.content) })
        : input;
};